<div class="bulk-edit-area flex-column flex-gap-6px">
  <div class="flex-row">
    <ukg-checkbox disabled="false" full-width="false" rounded-corners="true" [(ngModel)]="isBulkEditing"
      data-automation="enable-bulk-editing-check" ngDefaultControl>
      <ukg-label type="primary" translate data-automation="enable-bulk-editing-check-label">
        EMPLOYEE_PAYS.ACTION_POPUP_BULK_EDIT_LABEL
      </ukg-label>
    </ukg-checkbox>
    <ukg-banner [noMaxWidth]="true" type="information" class="flex-auto" *ngIf="enableStopPaymentInfoBox()">
      <span data-automation="notification_message" [innerHtml]="'EMPLOYEE_PAYS.ACTION_POPUP_EMAIL_MESSAGE' | translate"></span>
    </ukg-banner>
  </div>
  <div class="flex-row bulk-edit-dropdown-area flex-gap-20px" *ngIf="isBulkEditing">
    <div class="flex-row flex-gap-10px" *ngIf="hasCheckItems">
      <div class="flex-row">
        <span class="required-text">*</span>
        <span translate>EMPLOYEE_PAYS.ACTION_POPUP_BULK_EDIT_CHECK</span>
      </div>
      <ukg-input-container [block]="true" [size]="medium">
        <ukg-select data-automation="pay-action-confirmation-table-bulk-check-dropdown" [multiple]="false"
          placeholder="{{ 'EMPLOYEE_PAYS.CHECK_REASON_CODE_PLACEHOLDER' | translate }}" [(ngModel)]="bulkCheckCode">
          <ukg-select-option *ngFor="let item of checkNotificationCodes" [value]="item.original.code"
            [label]="item.translatedDescription | translate">
          </ukg-select-option>
        </ukg-select>
      </ukg-input-container>
    </div>
    <div class="flex-row flex-gap-10px" *ngIf="hasDDItems">
      <span translate>EMPLOYEE_PAYS.ACTION_POPUP_BULK_EDIT_DD</span>
      <ukg-input-container [block]="true" [size]="medium">
        <ukg-select data-automation="pay-action-confirmation-table-bulk-dd-dropdown" [multiple]="false"
          placeholder="{{ 'EMPLOYEE_PAYS.DD_REASON_CODE_PLACEHOLDER' | translate }}" [(ngModel)]="bulkDDCode">
          <ukg-select-option *ngFor="let item of ddNotificationCodes" [value]="item.original.code"
            [label]="item.translatedDescription | translate">
          </ukg-select-option>
        </ukg-select>
      </ukg-input-container>
    </div>
  </div>
</div>
<div class="pay-table-container flex-row">
  <div class="flex-fill flex-row">
    <div class="flex-0-0-100">
      <ukg-data-table-container>
        <ukg-data-table [columnNames]="allColumns">
          <table id="table">
            <thead id="head">
              <tr>
                <ng-container data-automation="pay-action-confirmation-table-column-removePay">
                  <ukg-th style="width:7%" data-automation="pay-action-confirmation-table-header-removePay">
                    <span data-automation="pay-action-confirmation-table-header-removePay-label"
                      translate>EMPLOYEE_PAYS.COLUMN_REMOVE
                    </span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="pay-action-confirmation-table-column-displayName">
                  <ukg-th style="width:13%" data-automation="pay-action-confirmation-table-header-displayName">
                    <span data-automation="pay-action-confirmation-table-header-displayName-label" translate>
                      EMPLOYEE_PAYS.COLUMN_NAME
                    </span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="pay-action-confirmation-table-column-payUtcDate">
                  <ukg-th style="width:9%" data-automation="pay-action-confirmation-table-header-payUtcDate">
                    <span data-automation="pay-action-confirmation-table-header-payUtcDate-label" translate>
                      EMPLOYEE_PAYS.COLUMN_PAY_DATE
                    </span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="pay-action-confirmation-table-column-payItemNumber">
                  <ukg-th style="width:9%" data-automation="pay-action-confirmation-table-header-payItemNumber">
                    <div class="inline-tooltip"
                      data-automation="pay-action-confirmation-table-header-payItemNumber-label">
                      <span [innerHtml]="'EMPLOYEE_PAYS.COLUMN_ITEM_NUMBER' | translate"></span>
                      <span class="clickable">
                        <ukg-icon (click)="itemNumberTooltip.present($event.target)" ssgHogClick placement="top" mode="toggle" name="help"
                          data-automation="column_item_number_tooltip_icon"></ukg-icon>
                      </span>
                    </div>
                    <ukg-popover #itemNumberTooltip type="standard">
                      <span>
                        <b><span [innerHtml]="'EMPLOYEE_PAYS.COLUMN_ITEM_NUMBER' | translate"></span></b>
                        <br>
                        <p data-automation="column_item_number_tooltip_text" translate>
                          EMPLOYEE_PAYS.COLUMN_ITEM_NUMBER_TOOLTIP
                        </p>
                      </span>
                    </ukg-popover>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="pay-action-confirmation-table-column-paymentType">
                  <ukg-th style="width:9%" data-automation="pay-action-confirmation-table-header-paymentType"><span
                      data-automation="pay-action-confirmation-table-header-paymentType-label"
                      translate>EMPLOYEE_PAYS.COLUMN_PAYMENT_TYPE</span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="pay-action-confirmation-table-column-payItemAmount">
                  <ukg-th style="width:9%" data-automation="pay-action-confirmation-table-header-payItemAmount"><span
                      data-automation="pay-action-confirmation-table-header-payItemAmount-label"
                      translate>EMPLOYEE_PAYS.COLUMN_ITEM_AMOUNT</span></ukg-th>
                </ng-container>
                <ng-container data-automation="pay-action-confirmation-table-column-reasonCode"
                  [class.reason-code-header-cell]="!isBulkEditing">
                  <ukg-th style="width:25%" data-automation="pay-action-confirmation-table-header-reasonCode">
                    <div>
                      <div data-automation="pay-action-confirmation-table-header-reasonCode-label" translate>
                        EMPLOYEE_PAYS.COLUMN_REASON_CODE</div>
                    </div>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="pay-action-confirmation-table-column-comment">
                  <ukg-th style="width:19%" data-automation="pay-action-confirmation-table-header-comment"><span
                      data-automation="pay-action-confirmation-table-header-comment-label"
                      translate>EMPLOYEE_PAYS.COLUMN_COMMENT</span>
                  </ukg-th>
                </ng-container>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let confirmationData of dataSource.source.value; let i = index">
                <tr>
                  <td data-automation="pay-action-confirmation-table-row-removePay" class="remove-cell">
                    <ukg-button parent-icon="close" [attr.aria-label]=" 'EMPLOYEE_PAYS.BUTTON_REMOVE_PAY' | translate "
                      (click)="removePay(confirmationData)"
                      data-automation="pay-action-confirmation-table-button-removePay" type="text" icon-only>
                    </ukg-button>
                  </td>
                  <td data-automation="pay-action-confirmation-table-row-displayName">
                    <span 
                      (mouseenter)="confirmationDataDisplayName.present($event.target)"
                      (mouseleave)="confirmationDataDisplayName.dismiss()">
                        {{confirmationData.displayName | truncate:30}}
                      </span>
                      <ukg-popover #confirmationDataDisplayName position="top">{{confirmationData.displayName}}</ukg-popover>
                  </td>
                  <td data-automation="pay-action-confirmation-table-row-payUtcDate">
                    <span data-automation="pay-action-confirmation-table-row-payUtcDate-content" class="cell-content"
                      (mouseenter)="confirmationDataPayDate.present($event.target)"
                      (mouseleave)="confirmationDataPayDate.dismiss()">
                        {{confirmationData.pay.payUtcDate | ultishortdate: 'L'}}
                    </span>
                    <ukg-popover #confirmationDataPayDate position="top">{{confirmationData.pay.payUtcDate | ultishortdate: 'L'}}</ukg-popover>
                  </td>
                  <td data-automation="pay-action-confirmation-table-row-payItemNumber">
                    <div data-automation="pay-action-confirmation-table-row-payItemNumber-content"
                      (mouseenter)="confirmationDataDocumentNumber.present($event.target)"
                      (mouseleave)="confirmationDataDocumentNumber.dismiss()" >
                        {{confirmationData.pay.documentNumber}}
                    </div>
                    <ukg-popover #confirmationDataDocumentNumber position="top">{{confirmationData.pay.documentNumber}}</ukg-popover>
                    <span *ngIf="confirmationData.payItem.maskedAccountNumber"
                      data-automation="pay-action-confirmation-table-row-payItemNumber-content"
                      (mouseenter)="confirmationDataMaskedAccountNumber.present($event.target)"
                      (mouseleave)="confirmationDataMaskedAccountNumber.dismiss()">
                        {{confirmationData.payItem.maskedAccountNumber}}
                    </span>
                    <ukg-popover #confirmationDataMaskedAccountNumber position="top">{{confirmationData.payItem.maskedAccountNumber}}</ukg-popover>
                  </td>
                  <td data-automation="pay-action-confirmation-table-row-paymentType">
                    <span data-automation="pay-action-confirmation-table-row-paymentType-content" class="cell-content"
                      (mouseenter)="confirmationDataPaymentType.present($event.target)"
                      (mouseleave)="confirmationDataPaymentType.dismiss()">
                        {{getPaymentTypeTextKey(confirmationData.payItem.paymentType) | translate | truncate:15}}
                    </span>
                    <ukg-popover #confirmationDataPaymentType position="top">{{getPaymentTypeTextKey(confirmationData.payItem.paymentType) | translate}}</ukg-popover>  
                  </td>
                  <td data-automation="pay-action-confirmation-table-row-payItemAmount">
                    <span data-automation="pay-action-confirmation-table-row-payItemAmount-content" class="cell-content nowrap"
                    (mouseenter)="confirmationDataAmount.present($event.target)"
                    (mouseleave)="confirmationDataAmount.dismiss()">
                      {{confirmationData.payItem.amount | ulticurrency:'1.02':undefined:true}}
                    </span>
                    <ukg-popover #confirmationDataAmount position="top">{{confirmationData.payItem.amount | ulticurrency:'1.02':undefined:true}}</ukg-popover>
                  </td>
                  <td data-automation="pay-action-confirmation-table-row-reasonCode"
                    class="overflow-cell vertical-align-middle">
                    <div class="flex-row">
                      <ng-container *ngIf="!isBulkEditing">
                        <span class="required-text">*</span>
                        <ukg-input-container block size="maximum" *ngIf="confirmationData.isCheck">
                          <ukg-select data-automation="pay-action-confirmation-table-code-check-dropdown"
                            class="reason-dropdown" [multiple]="false" [(ngModel)]="confirmationData.reasonCode">
                            <ukg-select-option *ngFor="let item of checkNotificationCodes" [value]="item.original.code"
                              [label]="item.translatedDescription | translate">
                            </ukg-select-option>
                          </ukg-select>
                        </ukg-input-container>
                        <ukg-input-container block size="maximum" *ngIf="confirmationData.isDirectDeposit">
                          <ukg-select data-automation="pay-action-confirmation-table-code-dd-dropdown"
                            class="reason-dropdown" [multiple]="false" [(ngModel)]="confirmationData.reasonCode">
                            <ukg-select-option *ngFor="let item of ddNotificationCodes" [value]="item.original.code"
                              [label]="item.translatedDescription | translate">
                            </ukg-select-option>
                          </ukg-select>
                        </ukg-input-container>
                      </ng-container>
                      <ng-container *ngIf="isBulkEditing">
                        <span data-automation="pay-action-confirmation-table-row-reasonCode-text" class="cell-content"
                        (mouseenter)="confirmationReasonCode.present($event.target)"
                        (mouseleave)="confirmationReasonCode.dismiss()">
                          {{ translateReasonCode(confirmationData) }}
                        </span>
                        <ukg-popover #confirmationReasonCode position="top">{{translateReasonCode(confirmationData)}}</ukg-popover>
                      </ng-container>
                    </div>
                  </td>
                  <td data-automation="pay-action-confirmation-table-row-comment"
                    class="vertical-align-middle comment-cell">
                    <ukg-input-container>
                      <ukg-input [(ngModel)]="confirmationData.comment" maxlength="250"
                        data-automation="pay-action-confirmation-table-row-comment-input" type="text">
                      </ukg-input>
                    </ukg-input-container>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </ukg-data-table>
      </ukg-data-table-container>
    </div>
  </div>
</div>
